export default (channel => payload => createAnalyticsEvent => {
  const consumerEvent = createAnalyticsEvent(payload);
  const clonedEvent = consumerEvent.clone();
  if (clonedEvent) {
    clonedEvent.fire(channel);
  }
  return consumerEvent;
});